var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.298,
    height: 12.361,
    viewBox: "0 0 13.298 12.361",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19825",
    "data-name": "Group 19825",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8633",
    "data-name": "Group 8633",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1226",
    "data-name": "Path 1226",
    d: "M12.432,228.2a.365.365,0,0,0-.367.367v3.335a1.645,1.645,0,0,1-1.643,1.643H2.377a1.645,1.645,0,0,1-1.643-1.643v-3.39a.367.367,0,1,0-.733,0v3.39a2.379,2.379,0,0,0,2.377,2.377h8.045a2.379,2.379,0,0,0,2.377-2.377v-3.335A.367.367,0,0,0,12.432,228.2Z",
    transform: "translate(0 -222.422)",
    fill: "#2bc7c9",
    stroke: "#2bc7c9",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1227",
    "data-name": "Path 1227",
    d: "M138.666,17.359a.369.369,0,0,1,.258-.109.358.358,0,0,1,.258.109l2.331,2.33a.367.367,0,1,1-.519.519l-1.7-1.706v7.439a.367.367,0,0,1-.733,0V18.5l-1.706,1.706a.367.367,0,1,1-.519-.519Z",
    transform: "translate(-132.525 -17.25)",
    fill: "#2bc7c9",
    stroke: "#2bc7c9",
    strokeWidth: 0.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/DownloadIcon.af1a2d6f8649012c7b6bfca5a37206f5.svg";
export { ForwardRef as ReactComponent };